import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherComponent } from './weather.component';
import { HorizontalScrollDirective } from './horizontal-scroll.directive';

@NgModule({
    declarations: [
        WeatherComponent,
        HorizontalScrollDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        WeatherComponent
    ]
})
export class NcWeatherModule { }